import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import GalleryViewer from '../components/GalleryViewer'
import ContactFormSection from '../components/ContactFormSection'

export default function NewBuild() {
  useEffect(() => {
    document.title = 'Nybyg - Kristensen Byg og Montage ApS'
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute(
        'content',
        'Mange års erfaring med nybyggeri og tæt samarbejde med større entreprenører. Jeg står for kvalitet, struktur og grundighed gennem hele byggeriet.'
      )
    }
  }, [])

  const getResizedUrl = (url, width, quality = 80) => {
    if (!url || !url.startsWith('https://assets.auxodev.dk/')) return url
    return url.replace(
      'https://assets.auxodev.dk/',
      `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=${quality},format=auto/`
    )
  }

  const mainImage = 'https://assets.auxodev.dk/assets/8ba53ab1-a105-4ab3-8373-4041e8d1e44e/newbuild-funkis-house.jpg'

  return (
    <div className="bg-white min-h-screen">
      {/* Service Details */}
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Column: Content */}
          <div className="space-y-6">
            <h3 className="text-2xl sm:text-3xl font-bold uppercase tracking-wider text-anthracite">
              Solidt samarbejde og kompromisløs kvalitet i nybyggeri
            </h3>
            <p className="text-sm sm:text-base text-warm-gray-600 leading-relaxed">
              At bygge nyt er en stor beslutning, der kræver en struktureret og erfaren samarbejdspartner. Hos Kristensen Byg og Montage ApS har jeg mange års erfaring med nybyggeri af moderne danske boliger, herunder både parcelhuse, funkishuse og arkitektegnede villaer.
            </p>
            <p className="text-sm sm:text-base text-warm-gray-600 leading-relaxed">
              Jeg arbejder tæt sammen med både private bygherrer og større entreprenører. Jeg forstår vigtigheden af stram projektstyring, overholdelse af tidsplaner og et fejlfrit resultat. Mit arbejde er kendetegnet ved høj præcision, struktur og en grundighed, der sikrer, at dit nye hjem står knivskarpt.
            </p>

            {/* Key highlights */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 pt-4">
              <div className="flex items-start gap-3">
                <i className="fa-light fa-check text-black mt-1 text-base" />
                <span className="text-sm font-semibold text-warm-gray-800">Mange års erfaring</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="fa-light fa-check text-black mt-1 text-base" />
                <span className="text-sm font-semibold text-warm-gray-800">Samarbejde med større kunder</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="fa-light fa-check text-black mt-1 text-base" />
                <span className="text-sm font-semibold text-warm-gray-800">Kvalitet i højsædet</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="fa-light fa-check text-black mt-1 text-base" />
                <span className="text-sm font-semibold text-warm-gray-800">Struktureret arbejdsproces</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="fa-light fa-check text-black mt-1 text-base" />
                <span className="text-sm font-semibold text-warm-gray-800">Uovertruffen grundighed</span>
              </div>
              <div className="flex items-start gap-3">
                <i className="fa-light fa-check text-black mt-1 text-base" />
                <span className="text-sm font-semibold text-warm-gray-800">Moderne danske materialer</span>
              </div>
            </div>

            <div className="pt-6">
              <Link
                to="/kontakt"
                className="inline-flex items-center justify-center rounded bg-brand-green px-5 py-2.5 text-sm font-bold text-white shadow-sm hover:bg-brand-green-hover transition-colors duration-200"
              >
                Kontakt mig
              </Link>
            </div>
          </div>

          {/* Right Column: Image */}
          <div className="relative aspect-4/3 overflow-hidden border border-warm-gray-200 shadow-md">
            <img
              src={getResizedUrl(mainImage, 800, 80)}
              alt="Nyopført moderne dansk funkis villa med store vinduespartier"
              className="h-full w-full object-cover"
            />
          </div>
        </div>
      </div>

      {/* Gallery Section */}
      <div className="bg-warm-gray-50 border-t border-b border-warm-gray-200 py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl mx-auto text-center mb-12">
            <h3 className="text-2xl sm:text-3xl font-bold uppercase tracking-wider text-anthracite">
              Udvalgte nybyggerier
            </h3>
          </div>

          {/* CMS Gallery Viewer */}
          <GalleryViewer slug="nybyg" />
        </div>
      </div>

      {/* Contact Form Section */}
      <ContactFormSection
        title="Planlægger du at bygge nyt?"
        subtitle="Uanset om du er privat bygherre eller repræsenterer en entreprenør, står jeg klar til at give et professionelt bud på tømrerentreprisen."
      />
    </div>
  )
}
